import { useState, useContext, useEffect } from "react";
import BorderChangeNotice from "../BorderChangeNotice";
import { Link } from "react-router-dom";
import { successToast, errorToast } from "../../../toastAlerts/ToastAlerts";
import { AdminPrimaryContext } from "../../../adminContext/AdminContext";
import {
  CheckBox,
  SelectInputValueId,
} from "../../../inputComponents/inputcomp";
import axiosAdmin from "../../../../../api/apiAdmin";
import RecipientAddressModal from "../RecipientAddressModal";
import AppeardPackagesItem from "./AppeardPackagesItem";
import PaginatedItems from "../../../Pagination/Pagination";
import { FaRegHandPointRight } from "react-icons//fa";
import { BiLoaderAlt } from "react-icons/bi";
import { BsX, BsTruck, BsFillEyeFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import OnWayBulkDispatch from "./OnWayBulkDispatch";
import { apiError } from "../../../../../api/apiError";

const AppeardPackages = () => {
  const { t } = useTranslation();
  //current filial
  const [currentPlaceId, setCurrentPlaceId] = useState(0);
  // Customs flags the last edit changed on OTHER parcels in the group.
  const [borderNotice, setBorderNotice] = useState(null);
  //branches data
  const { foreignAdresses, geBranches } = useContext(AdminPrimaryContext);
  //package data
  const [packageData, setPackageData] = useState([]);
  //package dataErr
  const [packageDataErr, setPackageDataErr] = useState([]);
  //affect data change depended on delete and add responses
  const [difResponses, setDifResponses] = useState(null);
  //package check all
  const [checkAll, setCheckAll] = useState(false);
  //search value and transportation
  const [search, setSearch] = useState({
    key: "",
  });
  //selected Packages
  const [selectedPackages, setSelectedPackages] = useState({
    pack_id: [],
  });
  //current page
  const [currentPage, setCurrentPage] = useState(0);
  //total count
  const [total, setTotal] = useState(0);
  //shipment code for express
  const [shipmentCode, setShipmentCode] = useState("");
  //is loading state
  const [isLoading, setIsLoading] = useState(false);
  //transportation
  const [transportation, setTransportation] = useState({
    transport: "",
    secured: "",
    geOffice: "",
  });
  //shipments
  const [shipments, setShipments] = useState([]);
  //border declaration status - track most critical among all packages
  const [borderDeclarStatus, setBorderDeclarStatus] = useState(0);
  //OnWay bulk dispatch modal
  const [onWayShow, setOnWayShow] = useState(false);
  //OnWay readiness summary for the whole status-3 set (not just this page)
  const [onWaySummary, setOnWaySummary] = useState(null);
  //show only packs the courier can deliver (pack address, or owner's default)
  const [onlyWithAddress, setOnlyWithAddress] = useState(false);
  //show only packs whose transport price is settled in full
  const [onlyPaid, setOnlyPaid] = useState(false);
  // Hide red (must declare) and yellow (held at customs): what is left can be
  // selected and moved 2.5 → 3 in one go.
  const [onlyCustomsClear, setOnlyCustomsClear] = useState(false);
  // Where the parcel stands with the courier (Pack::scopeOnwayState), and an
  // optional OnWay status on top of it.
  const [onway, setOnway] = useState("");
  const [onwayStatus, setOnwayStatus] = useState("");
  const [onwayStatuses, setOnwayStatuses] = useState({});
  // '' = both, '1' = revealed to the customer, '0' = still hidden (red eye).
  const [shown, setShown] = useState("");
  //cargo terminal the courier collects a flight from
  const [terminals, setTerminals] = useState([]);
  const [terminal, setTerminal] = useState("");
  const [assigning, setAssigning] = useState(false);

  //handle selected Packages
  const handleSelectedPackages = (value) => {
    if (!selectedPackages.pack_id.includes(value)) {
      setSelectedPackages((prev) => ({ pack_id: [...prev.pack_id, value] }));
    }
  };
  //handle delete selected Packages
  const handleDeleteSelectedPackages = (value) => {
    setSelectedPackages((prev) => ({
      pack_id: prev.pack_id.filter((obj) => {
        return obj !== value;
      }),
    }));
  };

  //handle change search value
  const handleSearchvalue = (e, inputName) => {
    setSearch((prev) => ({ ...prev, [inputName]: e.target.value }));
  };

  //handle transportation value
  const handleSearchTransport = (value, inputName) => {
    setTransportation((prev) => ({ ...prev, [inputName]: value }));
  };

  //handle checking
  const handleCheckAll = (e) => {
    setCheckAll(e.target.checked);
  };

  //current filial handler
  const handleCurrentPlaceId = (value) => {
    setCurrentPlaceId(value);
    setCheckAll(false);
    setSelectedPackages({
      pack_id: [],
    });
  };

  //const handle withdrawal package
  const handleSendAllWithdrawalPackages = async () => {
    try {
      const res = await axiosAdmin.post(`/packs/set`, {
        status: "4",
        ids: [...selectedPackages.pack_id],
      });
      if (res) {
        successToast(t("admin_action_success"));
        setDifResponses(res);
        setSelectedPackages({ pack_id: [] });
      }
    } catch (err) {
      if (err.response.status === 402) {
        errorToast(apiError(err, t("admin_package_fee_or_declaration_fee_unpaid")));
      } else {
        errorToast(apiError(err, t("admin_unpaid_package_or_other_error")));
      }
    }
  };

  //handle delete package
  const handleDeletePackage = async (id) => {
    try {
      const res = await axiosAdmin.delete(`/packs/${id}`);
      if (res) {
        setDifResponses(res);
        successToast(t("admin_package_deleted_success"));
      }
    } catch (err) {
      setPackageDataErr(err);
      errorToast(apiError(err, t("admin_error_try_again")));
    }
  };

  //handle show package
  const handleShowAllPackages = async () => {
    try {
      const res = await axiosAdmin.post(`/packs/set`, {
        status: "3",
        ids: [...selectedPackages.pack_id],
      });
      if (res) {
        setCheckAll(false);
        setSelectedPackages({
          pack_id: [],
        });
        setDifResponses(res);
        successToast(t("admin_shown_to_user_success"));

        // Revealing settles from the balance where it covers everything for
        // that customer; say what happened so the operator is not surprised
        // by parcels that turned green on their own.
        const ap = res?.data?.auto_paid;
        if (ap?.packs > 0) {
          successToast(
            `ბალანსიდან ავტომატურად გადაიხადა: ${ap.packs} ამანათი, ${ap.users} მომხმარებელი, ${Number(
              ap.amount
            ).toFixed(2)} ₾`
          );
        }
        if (ap?.skipped?.length) {
          errorToast(
            `${ap.skipped.length} მომხმარებელს ბალანსი არ ეყო ყველა ამანათისთვის — არაფერი ჩამოიჭრა`
          );
        }
      }
    } catch (err) {
      setPackageDataErr(err);
      errorToast(apiError(err, t("admin_error_try_again")));
    }
  };

  //data fetching
  const handleParcelInfo = () => {
    setIsLoading(true);
    axiosAdmin
      .get(
        `/packs?status=${3}&abroad_office_id=${currentPlaceId}&page=${
          currentPage + 1
        }` +
          `&per_page=${20}&addon_transp=${
            transportation.transport
          }&searchValue=${search.key}` +
          `&secured=${transportation.secured}` +
          `&repack=${
            transportation.repack === "false" ? "" : transportation.repack
          }` +
          `&office_id=${transportation.geOffice ? transportation.geOffice : ""}` +
          `&shipment_code=${shipmentCode || ""}` +
          `&has_address=${onlyWithAddress ? "true" : ""}` +
          `&paid=${onlyPaid ? "true" : ""}` +
          `&customs_clear=${onlyCustomsClear ? "true" : ""}` +
          `&onway=${onway}&onway_status=${onwayStatus}` +
          `&shown=${shown}`
      )
      .then(({ data }) => {
        setPackageData(data.data);
        setTotal(data.meta.total);
        setIsLoading(false);
      })
      .catch((err) => {
        setPackageDataErr(err);
      });
  };

  //terminal catalogue (from config, so a rename needs no deploy here)
  useEffect(() => {
    axiosAdmin
      .get(`/onway/options`)
      .then(({ data }) => {
        setTerminals(data?.terminals || []);
        setTerminal((prev) => prev || data?.default_terminal || "");
        setOnwayStatuses(data?.statuses || {});
      })
      .catch(() => {});
  }, []);

  //assign the pickup terminal to the flight currently filtered on
  const handleAssignTerminal = async () => {
    if (!shipmentCode) {
      errorToast("აირჩიეთ რეისი, რომელსაც ტერმინალს მიაბამთ");
      return;
    }
    const flight = shipments.find((s) => s.value === shipmentCode);
    if (!flight?.id) {
      errorToast("ამ რეისის იდენტიფიკატორი ვერ მოიძებნა");
      return;
    }
    setAssigning(true);
    try {
      const { data } = await axiosAdmin.post(
        `/shipments/${flight.id}/terminal`,
        { terminal }
      );
      successToast(`${data.code}: აღება — ${data.label}`);
      setDifResponses(Date.now());
    } catch (err) {
      errorToast(apiError(err, t("admin_error_try_again")));
    }
    setAssigning(false);
  };

  //OnWay readiness counts — covers every status-3 pack, not the current page
  const loadOnWaySummary = () => {
    axiosAdmin
      .get(`/onway/appeared`, {
        params: {
          declared: true,
          with_address: true,
          ...(currentPlaceId ? { abroad_office_id: currentPlaceId } : {}),
        },
      })
      .then(({ data }) => setOnWaySummary(data))
      .catch(() => setOnWaySummary(null));
  };

  //handle sent pack back
  const handleSendBack = (id) => {
    axiosAdmin
      .get(`/packs/back/${id}`)
      .then((res) => {
        successToast(t("admin_packages_returned_to_previous_section"));
        setDifResponses(res);
      })
      .catch((err) => {
        errorToast(err?.response?.data?.error || t("admin_error_try_again"));
      });
  };

  //update user
  // A different recipient opens the address popup first: the delivery
  // address belongs to the customer, and the previous owner's must not ride
  // along. Same recipient saves straight away.
  const [recipientPrompt, setRecipientPrompt] = useState(null);
  const handleGiveUserToParcel = (newData, packId) => {
    const current = packageData.find((p) => p.id === packId);
    const nextUser = newData?.userId;
    if (nextUser && String(nextUser) !== String(current?.user_id ?? "")) {
      setRecipientPrompt({ newData, packId, userId: nextUser, tracking: current?.tracking_number });
      return;
    }
    saveParcelEdit(newData, packId);
  };

  const saveParcelEdit = (newData, packId, addressId) => {
    axiosAdmin
      .put(`/packs/${packId}`, {
        user_id: newData.userId,
        ...(addressId !== undefined ? { user_address_id: addressId } : {}),
        total_weight: newData.weight,
        shipment_code: newData.flightNumber,
        transport_price: newData.transport_price,
        dementionY: newData.dementionY,
        dementionZ: newData.dementionZ,
        dementionX: newData.dementionX,
        addon_secur: newData.addon_secur,
      })
      .then((res) => {
        successToast(t("admin_changed_success"));
        setDifResponses(res);
        // The group changed, so siblings may have flipped colour on a page the
        // operator is not looking at.
        if (res?.data?.border_declaration?.length) {
          setBorderNotice(res.data.border_declaration);
        }
      })
      .catch(() => {
        errorToast(t("admin_error_try_again"));
      });
  };

  //on barcode scanner using
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleParcelInfo();
    }
  };

  const handleChangeTransportation = (parcelId) => {
    axiosAdmin
      .put(`/packs/${parcelId}`, {
        addon_transp: "",
        add_tr_price: "",
      })
      .then((res) => {
        setDifResponses(res);
        successToast("successful");
      })
      .catch(() => {
        errorToast("error");
      });
  };

  //package data fetching
  useEffect(() => {
    setCurrentPage(0);
  }, [search]);

  //compute most critical border_declar status
  useEffect(() => {
    if (packageData && packageData.length > 0) {
      // Priority: 3 (customs) > 1 (needs declaration) > 2 (declared) > 0 (not needed)
      let maxStatus = 0;
      for (let pkg of packageData) {
        const status = pkg.border_declar ?? 0;
        // 3 is highest priority (in customs), then 1 (needs declaration), then 2 (declared), then 0
        if (status === 3) {
          maxStatus = 3;
          break; // Stop at highest priority
        } else if (status === 1 && maxStatus !== 3) {
          maxStatus = 1;
        } else if (status === 2 && maxStatus === 0) {
          maxStatus = 2;
        }
      }
      setBorderDeclarStatus(maxStatus);
    } else {
      setBorderDeclarStatus(0);
    }
  }, [packageData]);

  //package data fetching
  useEffect(() => {
    handleParcelInfo();
    loadOnWaySummary();
  }, [
    currentPlaceId,
    difResponses,
    transportation,
    currentPage,
    shipmentCode,
    onlyWithAddress,
    onlyPaid,
    onlyCustomsClear,
    onway,
    onwayStatus,
    shown,
  ]);

  //package data fetching
  useEffect(() => {
    if (selectedPackages.pack_id.length > 0) {
      setCheckAll(false);
      setSelectedPackages({
        pack_id: [],
      });
    }
  }, [currentPage]);

  // Flights that can actually be on this page — the full shipments list is 500+
  // rows of mostly delivered flights, which made the dropdown useless.
  useEffect(() => {
    axiosAdmin
      .get(`/packs/flights`, {
        params: {
          status: 3,
          ...(currentPlaceId ? { abroad_office_id: currentPlaceId } : {}),
          ...(onlyWithAddress ? { has_address: true } : {}),
          ...(onlyPaid ? { paid: true } : {}),
          ...(onlyCustomsClear ? { customs_clear: true } : {}),
          ...(onway ? { onway } : {}),
          ...(onwayStatus ? { onway_status: onwayStatus } : {}),
        },
      })
      .then(({ data }) => {
        setShipments(
          (Array.isArray(data) ? data : []).map((item) => ({
            value: item.shipment_code,
            name: `${item.shipment_code} (${item.packs})${
              item.terminal_label ? ` — ${item.terminal_label}` : ""
            }`,
            id: item.shipment_id,
          }))
        );
      })
      .catch(() => {});
  }, [currentPlaceId, onlyWithAddress, onlyPaid, onlyCustomsClear, onway, onwayStatus, shown, difResponses]);

  return (
    <div
      className={`xl:ml-[280px] mt-[55px] dark:bg-slate-900 min-h-screen p-10 sm:p-5 pb-24 sm:pb-24 ${
        borderDeclarStatus === 0 ? 'bg-slate-100' :
        borderDeclarStatus === 1 ? 'bg-red-50' :
        borderDeclarStatus === 2 ? 'bg-green-50' :
        borderDeclarStatus === 3 ? 'bg-yellow-50' :
        'bg-slate-100'
      }`}
    >
      <div className="w-full overflow-auto scrollbar mb-5">
        <div className="flex gap-1 w-full md:w-[1000px] p-2">
          {foreignAdresses.map((item) => {
            return (
              <div
                key={item.id}
                className={`w-full flex items-center p-3 rounded-lg gap-5 cursor-pointer
                    shadow-[rgba(50,50,93,0.25)_0px_2px_5px_-1px,rgba(0,0,0,0.3)_0px_1px_3px_-1px] 
                    ${
                      currentPlaceId === item.id
                        ? "border border-green-500 bg-green-100"
                        : "bg-white dark:bg-slate-700 "
                    }`}
              >
                <div className="w-full flex flex-col gap-2">
                  <p className="text-[14px] text-[#8e95a8]">
                    {`${item.country} address`}
                  </p>
                  <div className="flex gap-1">
                    <div
                      onClick={() => {
                        handleCurrentPlaceId(item.id);
                      }}
                      className="w-full rounded-lg bg-green-400
                 flex items-center justify-center gap-1 p-1 py-3 text-white"
                    >
                      <FaRegHandPointRight />
                      <p>{t("admin_choose")}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h2 className="text-slate-400 text-2xl">{t("admin_arrived_packages")}</h2>
        <div className="flex items-center gap-3 flex-wrap">
          {/* Only offer packs the courier can actually deliver. */}
          <label className="flex items-center gap-2 text-sm dark:text-slate-200 cursor-pointer">
            <input
              type="checkbox"
              className="w-4 h-4"
              checked={onlyWithAddress}
              onChange={(e) => {
                setOnlyWithAddress(e.target.checked);
                setCurrentPage(0);
              }}
            />
            მხოლოდ მისამართიანი
          </label>

          <label className="flex items-center gap-2 text-sm dark:text-slate-200 cursor-pointer">
            <input
              type="checkbox"
              className="w-4 h-4"
              checked={onlyPaid}
              onChange={(e) => {
                setOnlyPaid(e.target.checked);
                setCurrentPage(0);
              }}
            />
            გადახდილი
          </label>

          {/* Red = must declare, yellow = held at customs. Neither can be
              released, so hide them: select all that remain, then "show". */}
          <label
            className="flex items-center gap-2 text-sm dark:text-slate-200 cursor-pointer"
            title="მალავს წითელ (დასადეკლარირებელ) და ყვითელ (საბაჟოზე დაკავებულ) ამანათებს — დარჩენილი შეგიძლიათ მონიშნოთ და 2.5-დან 3-ზე გადაიყვანოთ"
          >
            <input
              type="checkbox"
              className="w-4 h-4"
              checked={onlyCustomsClear}
              onChange={(e) => {
                setOnlyCustomsClear(e.target.checked);
                setCurrentPage(0);
                setCheckAll(false);
                setSelectedPackages({ pack_id: [] });
              }}
            />
            <span className="flex items-center gap-1">
              <span className="inline-block w-2.5 h-2.5 rounded-full bg-red-500" />
              <span className="inline-block w-2.5 h-2.5 rounded-full bg-yellow-400" />
              გარეშე
            </span>
          </label>

          {/* 2.5 has arrived but the customer cannot see it yet — the red eye
              on the card. 3 is revealed. The list holds both by default. */}
          <label className="flex items-center gap-2 text-sm dark:text-slate-200">
            <BsFillEyeFill className="text-slate-400" />
            <select
              className="h-8 px-2 border border-slate-300 dark:border-slate-600 rounded-md
                         bg-white dark:bg-slate-700 text-slate-800 dark:text-white text-sm"
              value={shown}
              onChange={(e) => {
                setShown(e.target.value);
                setCurrentPage(0);
              }}
              title="თვალი — გამოჩნდა თუ არა მომხმარებელთან"
            >
              <option value="">თვალი: ყველა</option>
              <option value="1">გამოჩენილი</option>
              <option value="0">დამალული</option>
            </select>
          </label>

          {/* Courier state. The second select narrows a live order to one of
              OnWay's own statuses; it only makes sense for sent parcels. */}
          <label className="flex items-center gap-2 text-sm dark:text-slate-200">
            <BsTruck className="text-slate-400" />
            <select
              className="h-8 px-2 border border-slate-300 dark:border-slate-600 rounded-md
                         bg-white dark:bg-slate-700 text-slate-800 dark:text-white text-sm"
              value={onway}
              onChange={(e) => {
                setOnway(e.target.value);
                if (!["sent", "live"].includes(e.target.value)) setOnwayStatus("");
                setCurrentPage(0);
                setCheckAll(false);
                setSelectedPackages({ pack_id: [] });
              }}
              title="საკურიერო — OnWay-სთან გაგზავნილია თუ არა"
            >
              <option value="">საკურიერო: ყველა</option>
              <option value="none">არ გაგზავნილა</option>
              <option value="never">არასდროს გაგზავნილა</option>
              <option value="sent">გაგზავნილია</option>
              <option value="live">კურიერთანაა (ჯერ არ ჩაბარდა)</option>
              <option value="delivered">ჩაბარებული</option>
              <option value="cancelled">გაუქმებული</option>
              <option value="failed">ვერ გაიგზავნა (თრექინგის გარეშე)</option>
            </select>
            {["sent", "live"].includes(onway) && (
              <select
                className="h-8 px-2 border border-slate-300 dark:border-slate-600 rounded-md
                           bg-white dark:bg-slate-700 text-slate-800 dark:text-white text-sm"
                value={onwayStatus}
                onChange={(e) => {
                  setOnwayStatus(e.target.value);
                  setCurrentPage(0);
                }}
                title="OnWay-ის სტატუსი"
              >
                <option value="">სტატუსი: ყველა</option>
                {Object.entries(onwayStatuses).map(([id, name]) => (
                  <option key={id} value={id}>
                    {name}
                  </option>
                ))}
              </select>
            )}
          </label>

          {/* Bulk courier dispatch — groups packs per customer + address.
              Opens with no warehouse selected too: the popup has its own
              warehouse and flight filters, so narrowing happens in there. */}
          <button
            onClick={() => setOnWayShow(true)}
            title="OnWay-ს გაგზავნა"
            className="flex items-center gap-2 rounded-lg text-white text-sm font-bold
                       px-4 py-2 bg-teal_600 hover:opacity-90"
          >
            <BsTruck className="text-lg" /> OnWay-ს გაგზავნა
          </button>
        </div>
      </div>

      {/* Courier readiness for every status-3 pack (all pages, current filial). */}
      <div className="flex flex-wrap gap-2 mt-2 text-xs">
        <span className="px-3 py-1.5 rounded-lg bg-white dark:bg-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-600">
          გასაგზავნი ამანათი:{" "}
          <b className="text-teal_600">{onWaySummary?.pack_count ?? "…"}</b>
        </span>
        <span className="px-3 py-1.5 rounded-lg bg-white dark:bg-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-600">
          შეკვეთა (გაერთიანების შემდეგ):{" "}
          <b className="text-teal_600">{onWaySummary?.group_count ?? "…"}</b>
        </span>
        {onWaySummary?.skipped_no_address > 0 && (
          <span
            className="px-3 py-1.5 rounded-lg bg-amber-50 text-amber-700 border border-amber-200"
            title="დეკლარირებულია, მაგრამ მისამართი არ აქვს — კურიერს ვერ გაეგზავნება"
          >
            მისამართის გარეშე:{" "}
            <b>{onWaySummary.skipped_no_address}</b>
          </span>
        )}
        {onWaySummary && onWaySummary.group_count > 0 && (
          <span
            className="px-3 py-1.5 rounded-lg bg-teal-50 text-teal-700 border border-teal-200"
            title="რამდენ შეკვეთას ზოგავს ერთი მომხმარებლის ამანათების გაერთიანება"
          >
            გაერთიანებით იზოგება:{" "}
            <b>{onWaySummary.pack_count - onWaySummary.group_count}</b> შეკვეთა
          </span>
        )}
      </div>

      {/* Which cargo terminal the courier collects the selected flight from.
          All three are around the airport, but the courier still needs the
          right gate. */}
      <div className="flex flex-wrap items-center gap-2 mt-2 text-xs">
        <span className="text-slate-500 dark:text-slate-300">აღების ტერმინალი:</span>
        <select
          className="h-8 px-2 border border-slate-300 dark:border-slate-600 rounded-md
                     dark:bg-slate-700 dark:text-white"
          value={terminal}
          onChange={(e) => setTerminal(e.target.value)}
        >
          {terminals.map((tr) => (
            <option key={tr.key} value={tr.key}>
              {tr.label}
            </option>
          ))}
        </select>
        <button
          onClick={handleAssignTerminal}
          disabled={assigning || !shipmentCode}
          title={
            shipmentCode
              ? `მიება რეისს ${shipmentCode}`
              : "აირჩიეთ რეისი ზემოთ"
          }
          className={`h-8 px-3 rounded-md text-white font-bold ${
            shipmentCode
              ? "bg-teal_600 hover:opacity-90"
              : "bg-slate-400 cursor-not-allowed"
          }`}
        >
          {assigning ? "..." : shipmentCode ? `მიბმა → ${shipmentCode}` : "მიბმა"}
        </button>
      </div>

      {onWayShow && (
        <OnWayBulkDispatch
          abroadOfficeId={currentPlaceId || undefined}
          shipmentCode={shipmentCode || undefined}
          onClose={() => setOnWayShow(false)}
          onDone={() => {
            setDifResponses(Date.now());
            loadOnWaySummary();
          }}
        />
      )}
      <div className="w-full">
        <div className="bg-yellow mt-2 flex gap-1 sm:flex-col">
          <div
            className="bg-white  pv-2 flex items-center hover:outline-slate-400 hover:outline-2
            hover:outline gap-x-1  px-3.5 py-1 rounded-lg dark:bg-slate-800 border-gray-300
            border dark:border-slate-600 w-9/12 sm:w-full"
          >
            <input
              type="search"
              placeholder="ძებნა: იუზერ ID / თრექინგი / რეისი"
              onChange={(e) => {
                handleSearchvalue(e, "key");
              }}
              className="w-full h-8 pl-1.5 focus:outline-none dark:text-white
                                dark:bg-slate-800 border-0"
              onKeyDown={handleKeyPress}
            />
          </div>
          <div className="flex items-center w-full">
            <SelectInputValueId
              options={shipments}
              inputName={"shipmentId"}
              inputSetter={(flight_num, _) => {
                setShipmentCode(flight_num);
              }}
              value={shipmentCode}
              defaultText={"რეისი (ფილტრი)"}
            />
            <BsX
              className="text-red-500 text-2xl shrink-0 cursor-pointer"
              onClick={() => {
                setShipmentCode("");
              }}
            />
          </div>
          <Link
            to={
              `${
                process.env.REACT_APP_API_URL
              }/api/exportPacks?status=${3}&abroad_office_id=${currentPlaceId}` +
              `&shipment_code=${shipmentCode}` +
              `&repack=${
                transportation.repack === "false" ? "" : transportation.repack
              }` +
              // Same filters as the list, so the sheet is what is on screen.
              `&office_id=${transportation.geOffice || ""}` +
              `&addon_transp=${transportation.transport || ""}` +
              `&secured=${transportation.secured === "true" ? "1" : ""}` +
              `&searchValue=${encodeURIComponent(search.key || "")}` +
              `&has_address=${onlyWithAddress ? "true" : ""}` +
              `&paid=${onlyPaid ? "true" : ""}` +
              `&customs_clear=${onlyCustomsClear ? "true" : ""}` +
              `&onway=${onway}&onway_status=${onwayStatus}` +
              `&shown=${shown}`
            }
            className="w-3/12 rounded-lg bg-green-400 sm:w-full
                 flex items-center justify-center p-1 py-3 text-white"
          >
            EXCEL (ფილტრით)
          </Link>
        </div>
        <div className="flex">
          <div className="flex items-center mt-2">
            <SelectInputValueId
              options={geBranches}
              inputName={"geOffice"}
              inputSetter={handleSearchTransport}
              // was bound to shipmentCode, which is a different filter
              value={transportation.geOffice}
              defaultText={t("admin_georgia_branches")}
            />
            <BsX
              className="text-red-500 text-2xl shrink-0 cursor-pointer"
              onClick={() => {
                handleSearchTransport("geOffice", "");
              }}
            />
          </div>
        </div>
        <div className="flex items-center justify-between my-2 flex-wrap gap-3 mt-2">
          <div className="flex gap-2 items-center sm:order-2 sm:flex-col sm:items-start">
            <CheckBox
              name={t("admin_transportation")}
              inputName={"transport"}
              handleCarData={handleSearchTransport}
            />
            <CheckBox
              name={t("admin_insured_packages")}
              inputName={"secured"}
              handleCarData={handleSearchTransport}
            />
            <div className="flex items-center gap-3">
              <input
                checked={checkAll}
                onChange={(e) => {
                  handleCheckAll(e);
                }}
                type="checkbox"
              />
              <p className="text-sm text-gray-500">{t("admin_select_all")}</p>
            </div>
            <CheckBox
              name={t("admin_repacked_packages")}
              inputName={"repack"}
              handleCarData={handleSearchTransport}
            />
          </div>
          <div className="flex gap-2 sm:flex-wrap">
            <div
              onClick={handleShowAllPackages}
              className="rounded-lg bg-yellow-400 sm:w-full
                 flex items-center justify-center gap-1 p-1 py-3 text-white cursor-pointer"
            >
              <p>{t("admin_show_to_user")}</p>
            </div>
            <div
              onClick={handleSendAllWithdrawalPackages}
              className="rounded-lg bg-green-400 sm:w-full cursor-pointer
                 flex items-center justify-center gap-1 p-1 py-3 text-white"
            >
              <p>{t("admin_deliver_selected")}</p>
            </div>
          </div>
        </div>
        <div className="w-full flex gap-3 flex-wrap mt-5">
          <PaginatedItems
            pageNumberSetter={setCurrentPage}
            dataLength={total}
            itemsPerPage={20}
          >
            {isLoading ? (
              <div className="mt-5 w-full flex items-center justify-center min-h-[200px]">
                <BiLoaderAlt className="w-20 h-20 animate-spin text-green-500" />
              </div>
            ) : isLoading === false && packageData.length === 0 ? (
              <div className="mt-5 w-full flex items-center justify-center min-h-[200px]">
                <p className="text-slate-600 text-sm">{t("admin_no_data_found")}</p>
              </div>
            ) : (
              <div className="w-full flex flex-col gap-2">
                {packageData.map((item) => {
                  return (
                    <AppeardPackagesItem
                      key={item.id}
                      data={item}
                      handleDeletePackage={handleDeletePackage}
                      setCheckedAll={checkAll}
                      handleSelectedPackages={handleSelectedPackages}
                      handleDeleteSelectedPackages={
                        handleDeleteSelectedPackages
                      }
                      setDifResponses={setDifResponses}
                      handleSendBack={handleSendBack}
                      handleGiveUserToParcel={handleGiveUserToParcel}
                      handleChangeTransportation={handleChangeTransportation}
                    />
                  );
                })}
              </div>
            )}
          </PaginatedItems>
        </div>
      </div>
      <BorderChangeNotice
        reports={borderNotice}
        onClose={() => setBorderNotice(null)}
      />
      {recipientPrompt && (
        <RecipientAddressModal
          packId={recipientPrompt.packId}
          tracking={recipientPrompt.tracking}
          userId={recipientPrompt.userId}
          onCancel={() => setRecipientPrompt(null)}
          onConfirm={(addressId) => {
            saveParcelEdit(recipientPrompt.newData, recipientPrompt.packId, addressId);
            setRecipientPrompt(null);
          }}
        />
      )}
    </div>
  );
};

export default AppeardPackages;
